import { AlertService } from './../../services/alert.service';
import { WorkspaceStore } from './../../services/stores/workspace.store';
import { ITreeNode } from './../../models/project/project.model';
import { Component, Inject, ViewChild, ElementRef } from '@angular/core';
import { BaseComponent } from '../base/base.component';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ImportHelper } from '../../services/helpers/import.helper';
import { ALLNODE, TESTNODEONLY, IMPORT_SCREEN_MODES, IMPORT_EVENTS } from '../../modules/catch-core/data/constants/import.constants';

@Component({
  selector: 'app-import-dialog',
  templateUrl: './import-dialog.component.html',
  styleUrl: './import-dialog.component.scss',
  standalone: false,
})
export class ImportDialogComponent extends BaseComponent {
  progressValue = 0;
  completed = 0;
  total = 0;
  public exportNodeSelection: string = ALLNODE;
  public importMode = IMPORT_SCREEN_MODES.IMPORT;
  @ViewChild('fileInput', { static: false }) fileInputElement?: ElementRef<HTMLInputElement>;

  constructor(
    public dialogRef: MatDialogRef<ImportDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public treeNode: ITreeNode,
    private workspaceStore: WorkspaceStore,
    private importHelper: ImportHelper,
    private alertService: AlertService,
  ) {
    super();
  }

  public onImport(): void {
    this.fileInputElement?.nativeElement?.click();
    this.importMode = IMPORT_SCREEN_MODES.IMPORTING;
  }

  public onCloseDialog(): void {
    this.workspaceStore.$getWorkspaceById(this.treeNode.id).subscribe((workspace) => {});
    this.dialogRef.close();
  }

  public onImportFile(e: Event): void {
    const input = e.target as HTMLInputElement;
    if (!input.files || input.files.length === 0) {
      return;
    }

    const file = input.files[0];
    // File-type validation lives in ImportHelper.importCSVHandler so an unsupported file is
    // written to the audit log as an "Import action failed..." entry instead of only a toast.
    if (this.exportNodeSelection.toLowerCase() === ALLNODE) {
      this.allNodeImportHandler(file);
    } else if (this.exportNodeSelection.toLowerCase() === TESTNODEONLY) {
      this.nodeWithTestStepImportHandler(file);
    }

    // Reset the value to allow re-selecting the same file
    input.value = '';
  }

  public adjustDialogSize(): void {
    this.dialogRef.updateSize('600px', '200px');
  }

  private allNodeImportHandler(file: File) {
    if (!file) {
      this.alertService.showErrorMessage('No file provided for import.');
      this.importMode = IMPORT_SCREEN_MODES.IMPORTING_FAILED;
      return;
    }

    this.importMode = IMPORT_SCREEN_MODES.IMPORTING;

    this.importHelper.importCSVHandler(file, ALLNODE).subscribe((event) => {
      if (event.type === IMPORT_EVENTS.IMPORT_EVENT_TYPE_PROGRESS_LOWER) {
        this.progressValue = Math.round((event.completed / event.total) * 100);
        this.completed = event.completed;
        this.total = event.total;
      } else if (event.type === IMPORT_EVENTS.IMPORT_EVENT_TYPE_DONE_LOWER) {
        if (event.success) {
          this.importMode = IMPORT_SCREEN_MODES.IMPORTING_SUCCESS;
        } else {
          this.alertService.showErrorMessage('Import failed. Please check the file format and content.');
          this.importMode = IMPORT_SCREEN_MODES.IMPORTING_FAILED;
        }
        this.adjustDialogSize();
      }
    });
  }

  private nodeWithTestStepImportHandler(file: File | null | undefined): void {
    if (!file) {
      //console.error('No file provided for import.');
      this.alertService.showErrorMessage('No file provided for import.');
      this.importMode = IMPORT_SCREEN_MODES.IMPORTING_FAILED;
      return;
    }

    this.importHelper.importCSVHandler(file, TESTNODEONLY).subscribe((event) => {
      if (event.type === 'progress') {
        this.progressValue = Math.round((event.completed / event.total) * 100);
        this.completed = event.completed;
        this.total = event.total;
      } else if (event.type === 'done') {
        if (event.success) {
          this.importMode = IMPORT_SCREEN_MODES.IMPORTING_SUCCESS;
        } else {
          this.alertService.showErrorMessage('Import failed. Please check the file format and content.');
          this.importMode = IMPORT_SCREEN_MODES.IMPORTING_FAILED;
        }
        this.adjustDialogSize();
      }
      // if (event) {
      //   this.importMode = IMPORT_SCREEN_MODES.IMPORTING_SUCCESS;
      //   // Optionally refresh workspace here
      //   // this.workspaceStore.$getWorkspaceById(this.treeNode.id).subscribe((workspace) => {});
      // } else {
      //   //console.error('Import failed. Please check the file format and content.');
      //   this.alertService.showErrorMessage('Import failed. Please check the file format and content.');
      //   this.importMode = IMPORT_SCREEN_MODES.IMPORTING_FAILED;
      // }
      // this.adjustDialogSize();
    });
  }
}
